export default "__VITE_ASSET__DN5$$H$z__"